import { useCallback, useEffect, useMemo } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'

import { getSelectedTab } from './helpers'

const useTabs = ({ tabs }) => {
  const navigate = useNavigate()
  const location = useLocation()

  const tabSelected = useMemo(
    () =>
      getSelectedTab(
        location.pathname,
        tabs.filter(tab => !tab.disabled)
      ),
    [location.pathname, tabs]
  )

  const onSelectTab = useCallback(element => navigate(element.path), [navigate])

  useEffect(() => {
    if (!tabSelected?.path) return
    if (location.pathname.includes(tabSelected.path)) return

    navigate(tabSelected.path, { replace: true })
  }, [tabSelected, location.pathname, navigate])

  return {
    tabSelected,
    onSelectTab,
  }
}

export default useTabs
